export default {
    text: "Tem dúvidas sobre seu pedido?<br/> Consulte nosso <a href='#' role='button' data-widget-trigger='{widgetOptions}'><b>Centro de Suporte</b></a> para obter ajuda"
}